import { NgModule } from '@angular/core'
import { CustomProductIntroComponent } from './custom-product-intro.component'
import { CommonModule } from '@angular/common'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { StarRatingModule } from '@spartacus/storefront'

@NgModule({
  imports: [CommonModule, I18nModule, StarRatingModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductIntroComponent: {
          component: CustomProductIntroComponent
        }
      }
    })
  ],
  declarations: [CustomProductIntroComponent],
  exports: [CustomProductIntroComponent]
})
export class CustomProductIntroModule {}
